import React from 'react'
import ServiceTemplate from '../../components/ServiceTemplate'
import { Palette, Eye, Smartphone, Users } from 'lucide-react'

const UIUXEngineering = () => {
  const features = [
    {
      icon: <Palette className="w-6 h-6" data-component-path="client/src/pages/services/UIUXEngineering.jsx" data-component-line="7:12" data-component-id="client/src/pages/services/UIUXEngineering.jsx:7:12" />,
      title: 'Modern Design',
      description: 'Beautiful interfaces that users love'
    },
    {
      icon: <Eye className="w-6 h-6" data-component-path="client/src/pages/services/UIUXEngineering.jsx" data-component-line="13:12" data-component-id="client/src/pages/services/UIUXEngineering.jsx:13:12" />,
      title: 'User Research',
      description: 'Data-driven design decisions'
    },
    {
      icon: <Smartphone className="w-6 h-6" data-component-path="client/src/pages/services/UIUXEngineering.jsx" data-component-line="19:12" data-component-id="client/src/pages/services/UIUXEngineering.jsx:19:12" />,
      title: 'Responsive Design',
      description: 'Perfect experience on all devices'
    },
    {
      icon: <Users className="w-6 h-6" data-component-path="client/src/pages/services/UIUXEngineering.jsx" data-component-line="25:12" data-component-id="client/src/pages/services/UIUXEngineering.jsx:25:12" />,
      title: 'Usability Testing',
      description: 'Validated with real user feedback'
    },
  ]

  return (
    <ServiceTemplate
      title="UI/UX Engineering"
      subtitle="Create intuitive experiences that delight users and drive engagement"
      description="We craft beautiful, intuitive interfaces backed by deep user research and usability testing. Our design process combines aesthetics with functionality to create experiences that users love and businesses benefit from."
      features={features}
      heroImage="https://images.pexels.com/photos/196644/pexels-photo-196644.jpeg?auto=compress&cs=tinysrgb&w=1920"
    />
  )
}

export default UIUXEngineering